<div class="dialog-title">
  <h3>  {{'Auctions.Delivered and collected' | translate}}</h3>
  <span mat-button mat-dialog-close>
      <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
          <path id="close-btn"
              d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
              transform="translate(5.82 13.32)" fill="#bbb" />
      </svg>
  </span>



</div>
<mat-dialog-content>

      <div class="register-user">
          <form (ngSubmit)="onSubmit()" [formGroup]="deliveredForm">
            <div class="inputs-form-section">
                <app-file-manager [label]="'files'" [files]="files" [isUploader]="false" [isSubmited]="formSubmitAttempt"
                  (selectedFiles)="files=$event;" (UploadLoading)="LoadingUploadMedia=$event"
                  [allowedExt]="['png','jpg','jpeg','pdf']" [MaxFileSize]="25" [maxFiles]="1" managerIndex="MediaImages"  [isRequired]="false"
                  [Mode]="'all'"></app-file-manager>
            </div>
            <div class="inputs-form-section">
              <mat-form-field  appearance="outline" class="form-group">
                <mat-label> {{'Auctions.Note'| translate}} </mat-label>
                <textarea maxlength="250" formControlName="note" matInput placeholder="" rows="10"></textarea>
              </mat-form-field>


            </div>
            
            <div class="group_btn">
              <button *ngIf="!loading" mat-button mat-dialog-close class="btnLight_fill" [appLoading]="loading">
                  {{'users.CANCEL' | translate}}
              </button>
              <button mat-button class="btn_fill" type="submit" [appLoading]="loading">
                 {{'users.save' | translate}}
              </button>


          </div>
          </form>

      </div>


</mat-dialog-content>